import $ from 'jquery';
import './_vportal.js';

// Expose jQuery globally for CDN scripts
window.jQuery = window.$ = $;

// Load twbsPagination CDN dynamically after jQuery is exposed
var loadTwbsPagination = function(callback) {
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/twbs-pagination/1.4.2/jquery.twbsPagination.min.js';
    script.onload = function() {
        callback();
    };
    script.onerror = function() {
        console.error('❌ Failed to load twbsPagination CDN');
    };
    document.head.appendChild(script);
};

$(window).on("load", function() {

    loadTwbsPagination(function() {

        $(".news").each(function() {
            var postsTag = "#" + $(this).attr("id");

            // Call vPortal on the jQuery object, not empty selector
            $(postsTag).vPortal({
                container: postsTag,
                el: {
                    tabContainer: '.news-tabs > a',
                    resultContainer: '.news-list',
                    viewAll: '.viewAll',
                },
                paginationOptions: {}
            });
        });
    });
});